export default __webpack_public_path__ + "static/media/blukit.8ccf27bf.png";